import isObject from 'lodash/isObject';

import TextListItem from './TextListItem';

const withData =
  (BaseTextList) =>
  ({ data, item: Item = TextListItem, count, title, children, ...props }) => {
    return (
      <BaseTextList
        title={title}
        count={count ? count : data ? data.length : 0}
        {...props}
        style={{ minWidth: 0 }}
      >
        {data && data.length
          ? data.map((model, i) => {
              if (isObject(model)) {
                return (
                  <Item key={i} index={i} {...model}>
                    {model.name}
                  </Item>
                );
              }

              return (
                <Item key={i} index={i}>
                  {model}
                </Item>
              );
            })
          : children}
      </BaseTextList>
    );
  };

export default withData;
